<template>
    <div :class="{ 'text-align-center': textAlignCenter }" class="flex-col">
        <small v-if="!hideDate" class="caption soli-grey">{{
            shortWeekday
                ? globalMomentWeekDayShort(date)
                : globalMomentWeekDay(date)
        }}</small>
        <div
            v-if="!hideDate"
            class="font-weight-bold soli-grey body-1 align-self-center whitespace-nowrap"
        >
            {{ globalMomentDateNoYear(date) }}
        </div>
        <small class="caption soli-grey">{{ globalMomentTime(date) }}</small>
    </div>
</template>

<script>
import globalMoment from "../../../Mixins/GlobalMoment.js";

export default {
    mixins: [globalMoment],
    props: {
        date: {
            type: String,
            default: null,
        },
        shortWeekday: {
            type: Boolean,
            default: false,
        },
        textAlignCenter: {
            type: Boolean,
            default: false,
        },
        hideDate: {
            type: Boolean,
            default: false,
        },
    },
};
</script>
